import { FillInputByLabelInstruction } from '../FillInputByLabelInstruction'

export class ExtraAddressInfoInstruction extends FillInputByLabelInstruction {
  constructor ({ label, waitForNoLoaders, value }) {
    super({
      name: 'ExtraAddressInfo',
      label,
      waitForNoLoaders,
      value

    })
  }

  setDefaultValue (params) {
    this.value = params.addressInformation.aditionalInfo
  }
}
